export const global_height_breakpoint_xl = {
  "name": "--pf-v5-global--height-breakpoint--xl",
  "value": "60rem",
  "var": "var(--pf-v5-global--height-breakpoint--xl)"
};
export default global_height_breakpoint_xl;